// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__35Jgp","label":"SetPasswdForm_label__wZRcB"};